import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LandingPage from "@/components/LandingPage";
import Dashboard from "@/components/Dashboard";
import OnboardingWizard from "@/components/OnboardingWizard";
import ProjectDetail from "@/components/ProjectDetail";
import LoginPage from "@/components/LoginPage";
import AuthCallback from "@/components/AuthCallback";
import ProfilePage from "@/components/ProfilePage";
import ContactPage from "@/components/ContactPage";
import ARMobileView from "@/components/ARMobileView";
import ShareView from "@/components/ShareView";
import InviteAcceptPage from "@/components/InviteAcceptPage";
import TermsPage from "@/components/TermsPage";
import TermsAcceptanceGate from "@/components/TermsAcceptanceGate";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Standalone, chrome-less route for the mobile AR experience (QR code target)
  if (location.pathname.startsWith("/ar/")) {
    return (
      <Routes>
        <Route path="/ar/:id" element={<ARMobileView />} />
      </Routes>
    );
  }
  // Standalone, chrome-less route for public Teaser-Share-Links
  if (location.pathname.startsWith("/share/")) {
    return (
      <Routes>
        <Route path="/share/:token" element={<ShareView />} />
      </Routes>
    );
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/new-project" element={<OnboardingWizard />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/invite/:token" element={<InviteAcceptPage />} />
      </Routes>
      <Footer />
      <TermsAcceptanceGate />
    </>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#05050A]">
            <AppRouter />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
